import { PropsWithChildren } from 'react';

import { Submit } from 'libs/form/Submit';
import { useTranslation } from 'libs/i18n';
import { Button, type ButtonProps, Stack } from 'libs/ui';

import { EmptyStateStyled, FormFooterStyled } from './FormFooter.styles';

export interface FormFooterProps extends PropsWithChildren {
  visible?: boolean;
}

export const FormFooter = ({ visible = true, children }: FormFooterProps) => {
  if (!visible) {
    return <EmptyStateStyled />;
  }

  return (
    <FormFooterStyled>
      <Stack
        alignItems="center"
        className="formFooter-content"
        direction="row"
        justifyContent="flex-end"
        spacing={24}
      >
        {children}
      </Stack>
    </FormFooterStyled>
  );
};

export const FormFooterCancel = ({ label, ...props }: ButtonProps) => {
  const { t } = useTranslation();

  return (
    <Button
      {...props}
      colorVariant="gray"
      label={label ?? t('common.cancel')}
      mode="outlined"
      sizeVariant="m"
    />
  );
};
export const FormFooterSubmit = ({ label, ...props }: ButtonProps) => {
  const { t } = useTranslation();

  return (
    <Submit {...props} label={label ?? t('common.save')} sizeVariant="m" />
  );
};
